<div [rvIsLoading]="!(patronSelector | select)" class="page-body-wrapper">
  <form [formGroup]="personalInfoForm" novalidate>
    <div class="account-header flex-row-wrap flex-center-space-between">
      <div class="mat-headline-4 account-title">Account</div>
    </div>
    <div class="account-row flex-row-wrap-col-responsive">
      <div class="account-column-1-3">
        <h3 class="account-subtitle">My Information</h3>
        <rv-input-form-field fieldName="firstName" [externalLabel]="true" overrideLabel="First Name"
                             [formGroup]="personalInfoForm"/>
        <rv-input-form-field fieldName="lastName" [externalLabel]="true" overrideLabel="Last Name"
                             [formGroup]="personalInfoForm"/>
        <div class="flex-row flex-gap-4">
          <rv-phone-form-field fieldName="phone1" [externalLabel]="true" overrideLabel="Primary Phone Number" [formGroup]="personalInfoForm"/>
          <div class="checkbox-wrapper">
            <rv-checkbox-form-field fieldName="phone1Mobile" overrideLabel="Mobile Phone" [formGroup]="personalInfoForm"/>
          </div>
        </div>
        <div class="flex-row flex-gap-4">
          <rv-phone-form-field fieldName="phone2" [externalLabel]="true" overrideLabel="Secondary Phone Number" [formGroup]="personalInfoForm"/>
          <div class="checkbox-wrapper">
            <rv-checkbox-form-field fieldName="phone2Mobile" overrideLabel="Mobile Phone" [formGroup]="personalInfoForm"/>
          </div>
        </div>

        <rv-input-form-field fieldName="email" [externalLabel]="true" [enabled]="false"
                             [formGroup]="personalInfoForm" [includeClearButton]="false"/>
        <!--                             (click)="updateEmail()" onKeyUp="updateEmail()"/>-->
        <!--        <a class="pointer" (click)="updateEmail()" onKeyUp="updateEmail()">Change email</a>-->
        <br/><br/>
        <rv-input-form-field fieldName="password" [externalLabel]="true" [enabled]="false"
                             [formGroup]="personalInfoForm" [includeClearButton]="false"
                             (click)="updatePassword()" onKeyUp="updatePassword()"/>
        <a class="pointer" (click)="updatePassword()" onKeyUp="updatePassword()">Change password</a>
        <br/><br/>
        <mat-label>PIN&nbsp;&nbsp;
          @if (patron.pinGenerated) {
            <em (click)="$event.stopPropagation()"
                class="ri-information-line pin-warning"
                matTooltip="Your pin may have been set by a staff member upon account creation, please update/change it here."></em>
          }
        </mat-label>
        <rv-input-form-field fieldName="pin" overrideLabel="" [enabled]="false"
                             [formGroup]="personalInfoForm" [includeClearButton]="false"
                             (click)="updatePin()" onKeyUp="updatePin()"/>
        <a class="pointer" (click)="updatePin()" onKeyUp="updatePin()">Change PIN</a>
      </div>
      <div class="account-column-2-3 flex-row-wrap-col-responsive">
        <div class="account-column-1-2">
          <h3 class="account-subtitle">Address</h3>
          <rv-input-form-field fieldName="address" [externalLabel]="true" [formGroup]="personalInfoForm"
                               overrideLabel="Street Address"/>
          <rv-input-form-field fieldName="address2" [externalLabel]="true" [formGroup]="personalInfoForm"
                               overrideLabel="Apartment, unit, suite, or floor #" errorLabel="This field"/>
          <rv-input-form-field fieldName="city" [externalLabel]="true" [formGroup]="personalInfoForm"
                               overrideLabel="City"/>
          <div class="flex-row flex-gap-12">
            <rv-select-form-field fieldName="state" [externalLabel]="true" overrideLabel="State/Province"
                                  [formGroup]="personalInfoForm"
                                  [options]="STATE_SELECT" [includeUndefinedOption]="false"/>
            <rv-input-form-field fieldName="zip" [externalLabel]="true" overrideLabel="Zip Code"
                                 [formGroup]="personalInfoForm" class="zip-field"/>
          </div>
        </div>
        <div class="account-column-1-2">
          <h3 class="account-subtitle">Library Information</h3>
          <rv-input-form-field fieldName="barcode" [externalLabel]="true" overrideLabel="Library Card Bar Code" [enabled]="false"
                               [formGroup]="personalInfoForm" [includeClearButton]="false"/>
          <rv-select-form-field fieldName="defaultBranch" [externalLabel]="true" overrideLabel="Pickup Location"
                                [formGroup]="personalInfoForm"
                                [options]="branchSelectors.branchesSelectOptions | select" [includeUndefinedOption]="false"/>
          <mat-checkbox formControlName="optIn">
            Save Reading History
          </mat-checkbox>
          <mat-checkbox formControlName="oneClickHoldsEnabled">
            One Click Holds
          </mat-checkbox>
          <!--        <mat-label>Theme</mat-label>-->
          <!--        <mat-form-field appearance="outline">-->
          <!--          <mat-select formControlName="theme">-->
          <!--            <mat-option *ngFor="let themeOpt of themeService.allThemes" [value]="themeOpt.value" (click)="themeService.setTheme(themeOpt.value)">-->
          <!--              {{themeOpt.label}}-->
          <!--            </mat-option>-->
          <!--          </mat-select>-->
          <!--        </mat-form-field>-->
        </div>
        @if (isFullSize) {
          <div class="dependent-table-full">
            <ng-container *ngTemplateOutlet="dependentTable"/>
          </div>
        }
      </div>
      @if (!(isMobile || isFullSize)) {
        <div class="dependent-table-full">
          <ng-container *ngTemplateOutlet="dependentTable"/>
        </div>
      }
      @if (isMobile) {
        <ng-container *ngTemplateOutlet="dependentTableMobile"/>
      }
    </div>
    <div class="clear-for-footer"></div>
    <div class="save-footer mat-elevation-z6">
      <div class="save-footer-content flex-row flex-center-end">
        <div class="spacer"></div>
        <div class="button-row-right">
          <button mat-stroked-button class="ButtonSmallBlack save-button-group button-cancel"
                  (click)="undo()" [disabled]="personalInfoForm.pristine">
            Undo
          </button>
          <button id="saveButton" mat-raised-button color="primary" class="ButtonSmallBlack save-button-group save-button"
                  [disabled]="personalInfoForm.pristine || personalInfoForm.invalid" (click)="submit()">
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #dependentTable>
  <h3 class="account-subtitle">Dependents</h3>
  <table mat-table class="non-mobile-table" aria-label="Dependents" [dataSource]="statusSelector.dependentAccounts | select">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef scope="col">Name</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentFullNameFor(dependent) | select }}
      </td>
    </ng-container>
    <ng-container matColumnDef="blocks">
      <th mat-header-cell *matHeaderCellDef scope="col">Blocks</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentHasAnyBlocksFor(dependent) | select | format:'YES_OR_NO' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="itemsOut">
      <th mat-header-cell *matHeaderCellDef scope="col">Items Out</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentItemsOutCountFor(dependent) | select }}
      </td>
    </ng-container>
    <ng-container matColumnDef="overdue">
      <th mat-header-cell *matHeaderCellDef scope="col">Overdue</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentOverdueCountFor(dependent) | select }}
      </td>
    </ng-container>
    <ng-container matColumnDef="totalHolds">
      <th mat-header-cell *matHeaderCellDef scope="col">Total Holds</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentActiveHoldCountFor(dependent) | select }}
      </td>
    </ng-container>
    <ng-container matColumnDef="readyForPickup">
      <th mat-header-cell *matHeaderCellDef scope="col">Ready For Pickup</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentReadyForPickupCountFor(dependent) | select }}
      </td>
    </ng-container>
    <ng-container matColumnDef="balance">
      <th mat-header-cell *matHeaderCellDef scope="col">Balance</th>
      <td mat-cell *matCellDef="let dependent">
        {{ statusSelector.dependentAccountBalanceFor(dependent) | select | format: 'CURRENCY' }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="dependentTableColumns" class="mx-bold-underline"></tr>
    <tr mat-row *matRowDef="let dependent; columns: dependentTableColumns">
    </tr>
  </table>
  @if (statusSelector.noDependents | select) {
    <div class="empty-list">
      No dependents.
    </div>
  }
</ng-template>

<ng-template #dependentTableMobile>
  <div class="account-column-1-3">
    <h3 class="account-subtitle">Dependents</h3>
    @for (dependent of statusSelector.dependentAccounts | select; track $index) {
      <div class="flex-col flex-gap-4 dependent-mobile-list">
        <div class="mat-subtitle-2">{{ statusSelector.dependentFullNameFor(dependent) | select }}</div>
        <div class="mat-caption flex-col flex-gap-4">
          <div>Blocks: {{ statusSelector.dependentHasAnyBlocksFor(dependent) | select | format:'YES_OR_NO' }}</div>
          <div>Items Out: {{ statusSelector.dependentItemsOutCountFor(dependent) | select }}</div>
          <div>Overdue: {{ statusSelector.dependentOverdueCountFor(dependent) | select }}</div>
          <div>Total Holds: {{ statusSelector.dependentActiveHoldCountFor(dependent) | select }}</div>
          <div>Ready For Pickup: {{ statusSelector.dependentReadyForPickupCountFor(dependent) | select }}</div>
          <div>Balance: {{ statusSelector.dependentAccountBalanceFor(dependent) | select | format: 'CURRENCY' }}</div>
        </div>
      </div>
    }
    @if (statusSelector.noDependents | select) {
      <div class="empty-list">
        No dependents.
      </div>
    }
  </div>
</ng-template>
